import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { StyledInput } from '../../../styles/common';
import { EnrollingDispatchContext } from '../../../context/EnrollingContext';
import { passFormId } from '../../../constants';
import SecureEntryIcon from '../../shared/SecureEntryIcon';

const PassWithData = ({ clearText, clearTextSwitch, setPass, validator, withPin }) => {
    const { t } = useTranslation();
    const enrollingDispatch = useContext(EnrollingDispatchContext);
    return (
        <FormGroup row data-test-id={passFormId} autoComplete="off">
            <Col xs="3">
                <Label for="pass">{t('formLabels$pass$formLabel')}</Label>
            </Col>
            <Col xs="4">
                <StyledInput
                    type={clearText ? 'text' : 'password'}
                    name="pass"
                    placeholder={withPin ? t('formLabels$pass$placeholder') : t('formLabels$passNoPin$placeholder')}
                    bsSize="sm"
                    onChange={(event) => {
                        enrollingDispatch({
                            type: 'SET_VALUE',
                            name: 'pass',
                            value: event.target.value,
                            validator,
                        });
                        setPass(event.target.value);
                    }}
                />
            </Col>
            <Col xs="0">
                <SecureEntryIcon
                    isActive={clearText}
                    onMouseDown={clearTextSwitch}
                />
            </Col>
        </FormGroup>
    );
};

PassWithData.propTypes = {
    clearText: PropTypes.bool.isRequired,
    clearTextSwitch: PropTypes.func.isRequired,
    setPass: PropTypes.func.isRequired,
    validator: PropTypes.func.isRequired,
};

export default PassWithData;
